module.exports = __webpack_public_path__ + "img/whatsApp-blue.1701f196.svg";